import React from "react";
import styles from "./Artwork.module.scss";
import everethArtworkHidden from "../../assets/evereth_artwork.png";
import { ReactComponent as LockIcon } from "../../assets/lock-icon.svg";
import { strings } from "../../strings";
import Button from "../Button/Button";

export default function Artwork({
  img = null,
  description,
  revealed,
  price,
  readMore,
  name,
  tags,
  link,
}) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.row}>
        <div className={styles.leftSide}>
          <div
            className={`${styles.imgBorder} ${
              name == "MARA" ? styles.mara : ""
            }`}
            onClick={() => readMore("read more")}
          >
            <img src={img} alt={"artwork"} />
            {revealed == false && (
              <div className={styles.hide}>
                <LockIcon />
                Artwork to be
                <br />
                revealed soon
              </div>
            )}
          </div>
        </div>
        <div className={styles.rightSide}>
          {/* <b className={styles.name}>{name}</b> */}
          <div className={styles.tags}>
            {tags.map((tag, i) => (
              <b>
                {tag}
                {i == tags.length - 1 ? "" : " - "}
              </b>
            ))}
          </div>
          <h4 className={styles.artworkHeader}>{strings.artworkHeader}</h4>
          <b>
            {description.substring(0, 110)}
            {"... "}
            <span onClick={() => readMore("read more")}>Read more</span>
          </b>
          {/* <div className={styles.links}>
            <b dangerouslySetInnerHTML={{ __html: price }} />
            <br />
            <a href={link} target={"_blank"}>
              View on Paras
            </a>
          </div> */}
        </div>
      </div>
      <div className={styles.actions}>
        <Button
          text={name == "1 of 1 BAG" ? "SOLD OUT" : strings.artworkBtn}
          action={() => {
            window.open(link, "_blank");
          }}
        />
        <b dangerouslySetInnerHTML={{ __html: price }} />
      </div>
    </div>
  );
}
